module.exports = __webpack_public_path__ + "static/media/update-bar.5bde57a4.svg";